<template>
    <v-form-group :label="label"
                  :description="description"
                  :error="error"
                  :state="errorState">
        <b-card :title="preview.file_name"
                :img-src="preview.url"
                img-top
                class="mb-2">
            <slot></slot>

            <div v-if="!readonly">
                <select-or-upload-field
                        v-if="!uploadOnly"
                        :name="name"
                        :readonly="readonly"
                        label="Upload Image"
                        :value="input"
                        @input="handleInput"
                />
                <upload-field
                        v-else
                        :name="name"
                        label="Upload Image"
                        :value="input"
                        @input="handleInput"
                />
            </div>
        </b-card>
    </v-form-group>
</template>

<script>
    import axios from 'axios'
    import SelectOrUploadField from './SelectOrUploadFileField.vue'
    import UploadField from './UploadFileField.vue'
    import field from '../../Mixins/field'

    export default {
        mixins: [field],
        components: {SelectOrUploadField, UploadField},
        props: {
            name: {},
            label: {},
            uploadOnly: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                preview: {}
            }
        },
        created() {
            this.fetchPreview(this.value);
        },
        methods: {
            async handleInput(fileId) {
                this.fetchPreview(fileId)
                this.$emit('input', fileId)
            },
            async fetchPreview(fileId) {
                if (!fileId) return;

                try {
                    let { data: result } = await axios.get('/api/files/' + fileId)
                    this.preview = result.data
                    this.$emit('preview', this.preview)
                } catch (ex) {}
            }
        }
    }
</script>